module.exports = __webpack_public_path__ + "img/angola.309979e1.svg";